// extracted by mini-css-extract-plugin
module.exports = {"container":"CommentsEditor_container__-SKXL","button":"CommentsEditor_button__3MUE4"};